// extracted by mini-css-extract-plugin
export default {"grid":"Home_grid__Ai2YO","section":"Home_section__nzxtE","wrapper":"Home_wrapper__IbSIS"};